export default class FetchExt {
    static getJson(url, options = {}) {
        options.method = 'GET';

        return FetchExt._fetch(url, options);
    }

    static postJson (url, options = {}) {
        options.method = 'POST';

        return FetchExt._fetch(url, options);
    }

    static _fetch(url, options = {}) {
        options = Object.assign(FetchExt._getDefaultOptions(), options);

        if (!(options.body instanceof FormData) && !!options.body) {
            let formData = new FormData();

            let keys = Object.keys(options.body);

            Array.prototype.forEach.call(keys, (key) => {
                formData.append(key, options.body[key]);
            });

            options.body = formData;
        }

        return fetch(url, options)
            .then(FetchExt._validationResponse)
            .then(FetchExt._processingResponse);
    }

    static _getDefaultOptions() {
        return {
            credentials: 'same-origin',
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            }
        };
    }

    static _validationResponse(response) {
        let isError = (!response.ok || (response.headers.get('content-length') === '0'));
        if (isError) {
            return {result: 'error', message: 'Ошибка!'};
        }

        if (response.ok && response.redirected) {
            window.location.href = response.url;

            return Promise.reject({result: 'redirect', response});
        }

        return response.json();
    }

    static _processingResponse(response) {
        if (response.result !== 'ok') {
            return Promise.reject(response);
        }

        return response;
    }
}